import React, { Component, Fragment } from 'react';
import styled, { css } from 'styled-components';
import AppBar from '@material-ui/core/AppBar';
import { colors } from '../../constants/colors';
import { getProfileColorTheme } from '../Account/util/colors';
import Logo from '../SolvPatternLibrary/Logo';
import { MOBILE_GUTTER } from '../../constants/layout';
import LoggedInMenu from './components/LoggedInMenu';
import MobileTabs from './components/MobileTabs';
import { safeGet } from '../../core/util/object';
import LoggedOutMenu from './components/LoggedOutMenu';
import history from '../../core/history';
import MichiganLogo from '../CoBrandedSRP/MichiganLogo';
import { isCobrandedSrpLocation } from '../CoBrandedSRP/util';
import CobrandedSrpLogo from '../CoBrandedSRP/CobrandedSrpLogo';

const StyledAppBar = styled(AppBar)`
  border: 0;
  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sc' does not exist on type 'ThemedStyled... Remove this comment to see the full error message
    sc: { isScrolled, noBorder } = {},
  }) =>
    css`
      box-shadow: ${isScrolled ? '0 4px 4px 0 rgba(0,0,0,0.2)' : 'unset'};
      border-bottom: ${isScrolled || noBorder ? '0' : `1px solid ${colors.dorianGrey}`};
    `}
`;

const Container = styled(({ isCobrandedSrp, ...rest }) => <div {...rest} />)`
  height: 60px;
  background-color: ${colors.whiteGrey};
  display: flex;
  justify-content: ${({ isCobrandedSrp }) => (isCobrandedSrp ? 'center' : 'space-between')};
  flex-direction: row;
  align-items: center;
`;

const LeftElement = styled.div`
  padding-left: ${MOBILE_GUTTER}px;
`;

const RightElement = styled.div`
  padding-right: ${MOBILE_GUTTER}px;
  padding-top: 14px;
`;

const StyledThinLogo = styled(Logo)`
  display: flex;
  padding-top: 16px;
  img {
    height: 24px;
  }
`;

type Props = {
  accountSummary?: any;
  handleLogout?: (...args: any[]) => any;
  isLoggedIn?: boolean;
  isScrolled?: boolean;
  noHeaderShadow?: boolean;
  logoOnly?: boolean;
  openLogInModal?: (...args: any[]) => any;
  openSignUpModal?: (...args: any[]) => any;
  selectedTabId?: string;
  tabProperties: any[];
  userProfile?: any;
  noBorder?: boolean;
  handleLogoOnClick?: (...args: any[]) => any;
};

class Mobile extends Component<Props> {
  getLoggedInRightElement = () => {
    const { userProfile, accountSummary, handleLogout } = this.props;
    const userProfileId = safeGet(userProfile)('user_profile_id');

    return (
      <LoggedInMenu
        accountSummary={accountSummary}
        currentProfile={userProfile}
        handleLogout={handleLogout}
        profileColor={getProfileColorTheme(accountSummary, userProfileId)}
      />
    );
  };

  getLoggedOutRightElement = () => (
    <LoggedOutMenu
      openLogInModal={this.props.openLogInModal}
      openSignUpModal={this.props.openSignUpModal}
    />
  );

  getRightElement = () => {
    if (this.props.isLoggedIn) {
      return this.getLoggedInRightElement();
    }

    return this.getLoggedOutRightElement();
  };

  handleLogoOnClick = () => {
    const { handleLogoOnClick } = this.props;
    if (handleLogoOnClick) {
      handleLogoOnClick();
    } else {
      history.push('/');
    }
  };

  render() {
    const { tabProperties, selectedTabId, isScrolled, noBorder, noHeaderShadow } = this.props;
    const isCobrandedSrp = isCobrandedSrpLocation();
    return (
      <>
        <Container isCobrandedSrp={isCobrandedSrp}>
          {isCobrandedSrp && <CobrandedSrpLogo />}
          <LeftElement>
            <StyledThinLogo handleLogoOnClick={this.handleLogoOnClick} />
          </LeftElement>
          <RightElement>
            {!this.props.logoOnly && !isCobrandedSrp && this.getRightElement()}
          </RightElement>
        </Container>
        {!this.props.logoOnly && !isCobrandedSrp && (
          <StyledAppBar
            position="sticky"
            // @ts-expect-error ts-migrate(2769) FIXME: Property 'sc' does not exist on type '(IntrinsicAt... Remove this comment to see the full error message
            sc={{
              isScrolled: isScrolled && !noHeaderShadow,
              noBorder,
            }}
          >
            <MobileTabs selectedTabId={selectedTabId} tabProperties={tabProperties} />
          </StyledAppBar>
        )}
      </>
    );
  }
}

export default Mobile;
